export default "__VITE_ASSET__57cefe0c__"